import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Grid,
  Chip,
  Avatar,
  IconButton,
  Button
} from '@mui/material';
import { 
  ArrowBack, 
  AccessTime, 
  CheckCircle, 
  Assignment 
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function MyTasksPage() {
  const navigate = useNavigate();

  // Mock data - In real app, fetch from API
  const tasks = [
    { id: 1, title: 'Concevoir la base de données', project: 'Projet Alpha', status: 'En cours', due: 'Demain', priority: 'Haute' },
    { id: 2, title: 'Créer les maquettes UI', project: 'Projet Alpha', status: 'À faire', due: 'Dans 3 jours', priority: 'Moyenne' },
    { id: 3, title: 'Rédiger la documentation', project: 'Site Web Corp', status: 'Terminé', due: 'Hier', priority: 'Basse' },
    { id: 4, title: 'Réunion client', project: 'Campagne Marketing', status: 'À faire', due: 'Aujourd\'hui', priority: 'Urgente' },
  ];

  const getStatusColor = (status) => {
    switch(status) {
      case 'En cours': return 'info';
      case 'Terminé': return 'success';
      case 'À faire': return 'default';
      default: return 'default';
    }
  };

  const getPriorityColor = (priority) => {
    switch(priority) {
      case 'Urgente': return 'error';
      case 'Haute': return 'warning';
      case 'Moyenne': return 'info';
      default: return 'default';
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: { xs: 2, md: 4 }, mb: { xs: 2, md: 4 } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <IconButton onClick={() => navigate('/dashboard')} sx={{ mr: 1 }}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h4" component="h1" fontWeight="bold" sx={{ fontSize: { xs: '1.5rem', md: '2.125rem' } }}>
          Mes Cartes
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {tasks.map((task) => (
          <Grid item xs={12} md={6} lg={4} key={task.id}>
            <Paper 
              elevation={2} 
              sx={{ 
                p: 2, 
                borderRadius: 2,
                borderLeft: 6,
                borderColor: `${getStatusColor(task.status)}.main`,
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 4
                }
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                <Chip 
                  label={task.project} 
                  size="small" 
                  variant="outlined" 
                  color="primary"
                />
                <Chip 
                  label={task.priority} 
                  size="small" 
                  color={getPriorityColor(task.priority)}
                  sx={{ height: 20, fontSize: '0.7rem' }}
                />
              </Box>
              
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                {task.title}
              </Typography>
              
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, color: 'text.secondary' }}>
                <AccessTime sx={{ fontSize: 16, mr: 0.5 }} />
                <Typography variant="caption" sx={{ mr: 2 }}>
                  {task.due}
                </Typography>
                
                <Box sx={{ flexGrow: 1 }} />
                
                <Chip 
                  label={task.status} 
                  size="small" 
                  color={getStatusColor(task.status)}
                  variant={task.status === 'Terminé' ? 'filled' : 'outlined'}
                />
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
      
      {tasks.length === 0 && (
        <Box sx={{ textAlign: 'center', py: 8, opacity: 0.6 }}>
          <Assignment sx={{ fontSize: 60, mb: 2 }} />
          <Typography variant="h6">Aucune carte assignée pour le moment</Typography>
        </Box>
      )}
    </Container>
  );
}

export default MyTasksPage;
